import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_products: { message: "idle" },
};

export const retrieve_products_Slice = createSlice({
 name: "retrieve_products",
 initialState,
 reducers: {
  success_retrieve_products: (state, action) => {
   state.retrieve_products = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_products: (state, action) => {
   state.retrieve_products = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_products: (state) => {
   state.retrieve_products = { status: app_consts.IDLE };
  },
  loading_retrieve_products: (state) => {
   state.retrieve_products = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_products, fail_retrieve_products, reset_retrieve_products, loading_retrieve_products } = retrieve_products_Slice.actions;

export default retrieve_products_Slice.reducer;